import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';
import Button from '../common/Button';

const ProjectSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const ProjectShowcase = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const ProjectImage = styled.div`
  flex: 1;
  
  img {
    width: 100%;
    border-radius: ${props => props.theme.borders.radius.regular};
    box-shadow: ${props => props.theme.shadows.regular};
  }
`;

const ProjectDetails = styled.div`
  flex: 1;
`;

const ProjectTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 10px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const ProjectMeta = styled.p`
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 20px;
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const ProjectDescription = styled.div`
  margin-bottom: 20px;
  
  p {
    margin-bottom: 15px;
    color: ${props => props.theme.colors.grey[600]};
    line-height: 1.8;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const ProjectHighlights = styled.div`
  margin-bottom: 30px;
  
  h4 {
    font-size: ${props => props.theme.fontSizes.medium};
    margin-bottom: 15px;
    color: ${props => props.theme.colors.secondaryColor};
  }
`;

const HighlightsList = styled.ul`
  list-style-position: inside;
  
  li {
    margin-bottom: 10px;
    color: ${props => props.theme.colors.grey[600]};
    line-height: 1.7;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const FeaturedProject = () => {
  return (
    <ProjectSection>
      <div className="container">
        <SectionHeader 
          title="Featured Project" 
          subtitle="Highlighting our most impactful work" 
        />
        
        <ProjectShowcase>
          <ProjectImage>
            <img src="/placeholder/600/400" alt="Featured Project" />
          </ProjectImage>
          
          <ProjectDetails>
            <ProjectTitle>Multi-story Residential Complex Design</ProjectTitle>
            <ProjectMeta>Location: Chennai | Year: 2024</ProjectMeta>
            
            <ProjectDescription>
              <p>
                This project involved the complete structural design and analysis of a 15-story 
                residential complex in Chennai. The design incorporated earthquake-resistant features 
                and innovative construction techniques to optimize both safety and cost-effectiveness.
              </p>
              <p>
                Our team conducted detailed soil analysis, foundation design, structural framework planning, 
                and development of construction specifications. The project was completed on schedule and has 
                been praised for its structural integrity and innovative design solutions.
              </p>
            </ProjectDescription>
            
            <ProjectHighlights>
              <h4>Project Highlights:</h4>
              <HighlightsList>
                <li>Earthquake-resistant design incorporating base isolation techniques</li>
                <li>Integration of sustainable building materials</li>
                <li>Optimization of structural elements to reduce material usage</li>
                <li>Innovative foundation design for challenging soil conditions</li>
              </HighlightsList>
            </ProjectHighlights>
            
            <Button variant="primary">View Full Case Study</Button>
          </ProjectDetails>
        </ProjectShowcase>
      </div>
    </ProjectSection>
  );
};

export default FeaturedProject;